export default "__VITE_ASSET__05fff482__"